<template>
  <nav class="navbar" aria-label="主导航">
    <div class="navbar-container">
      <router-link to="/" class="navbar-brand">
        {{ isLogin ? `${username} 的博客` : 'x-shuffle' }}
      </router-link>

      <button
        type="button"
        class="navbar-toggle"
        :aria-expanded="mobileMenuOpen ? 'true' : 'false'"
        aria-controls="primary-navigation"
        :aria-label="mobileMenuOpen ? '关闭导航菜单' : '打开导航菜单'"
        @click="toggleMobileMenu">
        <i :class="mobileMenuOpen ? 'el-icon-close' : 'el-icon-menu'" aria-hidden="true"></i>
      </button>

      <div
        id="primary-navigation"
        class="navbar-menu"
        :class="{ 'is-open': mobileMenuOpen }">
        <router-link to="/categories" class="nav-item">分类</router-link>
        <router-link to="/todo" class="nav-item">Todo</router-link>
        <a
          href="https://nv.x-shuffle.com/"
          target="_blank"
          rel="noopener noreferrer"
          class="nav-item external-link">导航页</a>
        <template v-if="!isLogin">
          <router-link to="/login" class="nav-item">登录</router-link>
          <router-link to="/register" class="nav-item">注册</router-link>
        </template>
        <button v-else type="button" @click="handleLogout" class="nav-item nav-button">退出</button>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'NavBar',
  data() {
    return {
      isLogin: false,
      username: '',
      mobileMenuOpen: false
    }
  },
  methods: {
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen
    },
    closeMobileMenu() {
      this.mobileMenuOpen = false
    },
    handleKeydown(event) {
      if (event.key === 'Escape') {
        this.closeMobileMenu()
      }
    },
    handleLogout() {
      localStorage.removeItem('token')
      localStorage.removeItem('username')
      this.isLogin = false
      this.username = ''
      this.$router.push('/login')
      this.$message.success('已退出登录')
    },
    checkLoginStatus() {
      const token = localStorage.getItem('token')
      const username = localStorage.getItem('username')
      if (token && username) {
        this.isLogin = true
        this.username = username
      } else {
        this.isLogin = false
        this.username = ''
      }
    }
  },
  created() {
    this.checkLoginStatus()
  },
  mounted() {
    document.addEventListener('keydown', this.handleKeydown)
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeydown)
  },
  // 监听路由变化，更新登录状态
  watch: {
    '$route'() {
      this.checkLoginStatus()
      this.closeMobileMenu()
    }
  }
}
</script>

<style scoped>
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 64px;
  background: #f5f0e8;  /* 更浅的米色背景 */
  box-shadow: 0 2px 8px rgba(107, 95, 76, 0.08);  /* 暖色调阴影 */
  z-index: 1000;
  border-bottom: 1px solid rgba(107, 95, 76, 0.1);  /* 暖色调边框 */
}

.navbar-container {
  width: min(calc(100% - 2rem), var(--shell-width));
  margin: 0 auto;
  padding: 0;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}

.navbar-brand {
  font-size: 1.5rem;
  font-weight: 700;
  color: #6b5f4c;  /* 暖棕色 */
  text-decoration: none;
  transition: color 0.2s ease;
}

.navbar-brand:hover {
  color: #4361ee;  /* 保持主色调 */
}

.navbar-menu {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

.nav-item {
  color: #6b5f4c;  /* 暖棕色 */
  text-decoration: none;
  font-size: 1rem;
  transition: all 0.2s ease;
  cursor: pointer;
  padding: 0.5rem 0.75rem;
  border-radius: 6px;
  min-height: 40px;
  display: inline-flex;
  align-items: center;
}

.nav-button {
  border: 0;
  background: transparent;
}

.navbar-toggle {
  display: none;
  width: 44px;
  height: 44px;
  padding: 0;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #6b5f4c;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  font-size: 1.25rem;
}

.navbar-toggle:hover,
.navbar-toggle:focus-visible {
  background: rgba(67, 97, 238, 0.07);
  color: var(--primary-color);
  outline: none;
}

.nav-item:hover {
  color: #4361ee;  /* 主色调 */
  background: rgba(67, 97, 238, 0.05);  /* 主色调的淡色背景 */
}

.external-link {
  position: relative;
}

.external-link::after {
  content: '↗';
  margin-left: 4px;
  font-size: 0.8em;
  opacity: 0.7;
}

.external-link:hover::after {
  opacity: 1;
}

.router-link-exact-active {
  color: #4361ee;  /* 主色调 */
  font-weight: 500;
}

@media (max-width: 768px) {
  .navbar {
    height: 56px;
  }

  .navbar-container {
    width: calc(100% - 1.5rem);
    padding: 0;
  }

  .navbar-brand {
    font-size: 1.25rem;
  }

  .navbar-toggle {
    display: inline-flex;
  }

  .navbar-menu {
    display: none;
    position: absolute;
    top: calc(100% + 0.5rem);
    left: 0;
    right: 0;
    padding: 0.5rem;
    flex-direction: column;
    align-items: stretch;
    gap: 0.25rem;
    background: var(--card-bg);
    border-radius: 12px;
    box-shadow: 0 8px 24px rgba(107, 95, 76, 0.16);
  }

  .navbar-menu.is-open {
    display: flex;
  }

  .nav-item {
    width: 100%;
    min-height: 44px;
    font-size: 1rem;
    padding: 0.65rem 0.75rem;
  }
}
</style>
